import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SystemApiService } from '@cv-invision/core';

@Injectable({
	providedIn: 'root'
})
export abstract class EditableTableService {
	constructor(public httpClient: HttpClient, public systemApiService: SystemApiService) {}

	/**
	 * Get Data
	 */
	abstract getData(): Observable<any>

    /**
	 * Get Data
	 */
	abstract saveData(data: Array<any>): Observable<any>
}
